class Toggler{
    toggle(entry){
        entry.onclick = (event) => {
            let data_target = entry.getAttribute('data-click-target'),
                toggler = document.querySelector(data_target)

            toggler.click()
        }
    }

    onMouseEnter = (event) => { /** Code your own */ }

    onMouseLeave = () => { /** Code your own */ }

    destroy = () => { /** Code your own */ }
}

export const TogglerManager = new Toggler()